module.exports = __webpack_public_path__ + "img/img-make-background-image-new.1202ab7c.svg";